import { id } from "date-fns/locale";
import {post} from "./base";

export function getAll(accessToken) {
  return post("target/GetTargets", {accessToken});
}

export async function add(data) {
  // data: FormData -> remember to add accessToken
  await post("target/AddTarget", {accessToken: data['accessToken'], formBody: data});
  console.log(`Target ${data['id']} added`);
}
export async function remove(accessToken, idCampione) {
  await post("target/DeleteCampione", {jsonBody: {accessToken, idCampione}});
  console.log(`Target ${idCampione} deleted`);
}

export async function getTargets(accessToken) {
  const res = await post("target/GetTargets", {accessToken});
  return res.map((t) => ({
    ...t,
    id: t.id,
    name: t.name,
    description: t.description,
    // Add any additional processing here if needed
  }));
  // if (!res.ok) {
  //   throw new Error("Failed to fetch targets");
  // }
  // return res;
}
